<h4 class="mobi-ui-font-size-400">
  <span class="block font-bold mobi-ui-font-size-50 mb-2 text-black">
    {{ 'non_binding' | texts: { context: 'primcalc', default: 'Unverbindliche' } }}
  </span>
  {{ 'calculation' | texts: { context: 'primcalc', default: 'Berechnung' } }}
</h4>
<dl
  class="mobi-ui-card-fullwidth mobi-ui-list-silent is-description-list mobi-ui-margin-t-md mobi-ui-text-has-border mobi-ui-font-size-50"
>
  <dt class="mobi-ui-font-h6">
    {{
      'max_buy_price' | texts: { context: 'primcalc', default: 'Maximaler Kaufpreis *' }
    }}
  </dt>
  <dd>CHF&nbsp;{{ formatNumber(result.max_buy_price, '0,0.00') }}</dd>
</dl>
<dl
  class="mobi-ui-card-fullwidth mobi-ui-list-silent is-description-list mobi-ui-margin-t-md mobi-ui-text-has-border mobi-ui-font-size-50"
>
  <dt class="mobi-ui-font-h6">
    {{
      'needed_mortgage' | texts: { context: 'primcalc', default: 'Benötigte Hypothek' }
    }}
  </dt>
  <dd>CHF&nbsp;{{ formatNumber(result.needed_mortgage, '0,0.00') }}</dd>
</dl>
